<template>
  <div class="a-accordion__collapse ">
    <div class="a-accordion__tab" v-for="item in records">
      <div class="a-accordion__btn-tab ">
        <div class="a-accordion__label a-accordion__label--open" :class="{ 'a-accordion__block-edit': item.editable }">
          <img src="@/assets/img/static/arrow-vector.png" alt="">
          <div class="a-form-field" v-if="item.editable" style="width: 100%">
            <input type="text" class="a-input" v-model="item.name" @keyup.enter="onConfirmClick(item)">
            <span class="a-helper-text a-validation-error" v-if="item.error">{{$t('labels.mandatory-field')}}</span>
          </div>
          <span v-else>{{item.name}}</span>
        </div>

        <template v-if="item.editable">
          <button class="a-accordion__ok-btn" type="button" @click="onConfirmClick(item)">
            <img src="@/assets/img/static/tab-ok.svg">
          </button>
          <button class="a-accordion__clear-btn" type="button" @click="onCancelClick(item)">
            <img src="@/assets/img/static/tab-close.svg">
          </button>
        </template>

        <template v-else>
          <button class="a-accordion__editing-btn" type="button" @click="$emit('editItem', item)">
            <img src="@/assets/img/static/b-icon_edit.svg">
          </button>
          <button class="a-accordion__add-btn" type="button" @click="$emit('addItem', { parentId: item.id, level: item.level + 1 })" v-if="item.level < 6">
            <img src="@/assets/img/static/b-icon_plus-str.svg">
          </button>
          <button class="a-accordion__remove-btn" type="button" @click="$emit('deleteItem', item)">
            <img src="@/assets/img/static/trashcan.svg">
          </button>
        </template>
      </div>

      <departments-catalog-level
        :levels="levels"
        :level="level + 1"
        :parentId="item.id"
        @addItem="$emit('addItem', $event)"
        @editItem="$emit('editItem', $event)"
        @deleteItem="$emit('deleteItem', $event)"
        @confirmEditable="$emit('confirmEditable', $event)"
        @cancelEditable="$emit('cancelEditable', $event)"
        v-if="!item.isNew"
      ></departments-catalog-level>
    </div>
  </div>
</template>

<script>
  import { required } from '@/validators'

  export default {
    name: 'DepartmentsCatalogLevel',

    props: {
      levels: Array,
      level: Number,
      parentId: Number,
      isNew: Boolean
    },

    computed: {
      records() {
        let items = (this.levels[this.level] || []);

        if (this.parentId) {
          items = items.filter(e => e.parentId === this.parentId)
        }

        return items;
      }
    },

    methods: {
      onConfirmClick(item) {
        if (!required(item.name)) {
          this.$set(item, 'error', true);
          return;
        }

        this.$set(item, 'error', false);
        this.$emit('confirmEditable', item);
      },

      onCancelClick(item) {
        this.$emit('cancelEditable', item);
      }
    }
  }
</script>

<style scoped>

</style>
